import styled from 'styled-components';

export const FooterWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 12px;
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const IconWrapper = styled.span`
  display: flex;
  width: 80px;
  height: 80px;
  padding: 12px 13px 13px 12px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  font-size: 55px;
`;

export const TitleWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
`;
